<!-- 我申请的专家评估-->
<template>
  <div class="apply">
    <el-form :inline="true" :model="form" class="qForm" :size="queryFormSize">
      <el-form-item label="评估状态">
        <el-select
          v-model="form.reviewApplyStatus"
          placeholder="请选择分类"
          clearable
        >
          <el-option
            :label="item.dictLabel"
            :value="item.dictValue"
            v-for="(item, index) in applyStatusOption"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker
          v-model="form.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryBtn" :loading="loading"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div class="apply-table">
      <el-table :data="lists" border v-loading="loading">
        <el-table-column prop="userName" label="用户名称"> </el-table-column>
        <el-table-column prop="expertName" label="专家名称"> </el-table-column>
        <el-table-column label="评估状态">
          <template slot-scope="{ row }">
            {{ statusMap[+row.reviewApplyStatus] }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间">
          <template slot-scope="{ row }">
            <div>{{ row.createTime | transformTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="viewBtn(scope.row)" size="mini"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <DetailDialog v-model="showDrawer" :data="selectData" v-if="showDrawer" />
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      @pageIndexChange="handlePageChange"
    />
  </div>
</template>
<script>
import { parseTime } from "@/utils/index";
import { QUERY_FORM_SIZE } from "@/constant/size";
import Pagination from "@/components/Pagination/index";
import DetailDialog from "@/components/EstimateDetail/index";
import { myEstList } from "@/api/expert";
import { EST_APPLY_STATUS } from "@/constant/dict";
export default {
  components: {
    Pagination,
    DetailDialog,
  },
  filters: {
    transformTime(val) {
      return parseTime(val);
    },
  },
  data() {
    return {
      queryFormSize: QUERY_FORM_SIZE,
      showDrawer: false,
      form: { reviewApplyStatus: null, time: [] },
      totalItem: 0,
      lists: [],
      selectData: {},
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      applyStatusOption: [],
      statusMap: {},
      loading: false,
    };
  },
  created() {
    this.getStatus();
    this.getList();
  },
  methods: {
    async getStatus() {
      const data = await this.$store.dispatch("getDictData", EST_APPLY_STATUS);
      this.applyStatusOption = data;
      const statusMap = {};
      data.forEach((item) => {
        statusMap[item.dictValue] = item.dictLabel;
      });

      this.statusMap = statusMap;
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { reviewApplyStatus, time } = this.form;
      const params = {
        ...this.page,
        checkUserType: "PU", // 查询用户类别（PU-平台用户；PE-专家）
        reviewApplyStatus,
      };
      if (time && time.length) {
        const day = 24 * 60 * 60 * 1000;
        Object.assign(params, {
          startReviewDate: time[0],
          endReviewDate: time[1] + day,
        });
      }
      const { totalItem, list } = await this.$axios
        .post(myEstList, params)
        .finally(() => {
          this.loading = false;
        });
      this.lists = list;
      this.totalItem = totalItem;
    },
    queryBtn() {
      this.page.pageIndex = 1;
      this.getList();
    },
    viewBtn(data) {
      this.selectData = data;
      this.showDrawer = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.apply {
  padding: 10px;
  &-table {
    min-height: 450px;
    margin-bottom: 10px;
  }
}
.qForm {
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
